import React, { useMemo } from 'react'
import { useEthers, useTransactions } from '../../hooks'
import { Modal } from '../Modal'
import { HistoryItem } from './HistoryItem'
import styled from 'styled-components'
import { Colors } from '../../constants'
import { UnsupportedChainIdError } from '@web3-react/core'

interface Props {
  onClose: () => void
}

export function HistoryModal({ onClose }: Props) {
  const { account, error } = useEthers()
  const { transactions } = useTransactions()
  const reversed = useMemo(() => [...transactions].reverse(), [transactions])

  let content
  if (error instanceof UnsupportedChainIdError) {
    content = <StatusText>Unsupported network. Please connect with a supported network.</StatusText>
  } else if (!account) {
    content = <StatusText>Connect your wallet to see your history.</StatusText>
  } else if (reversed.length > 0) {
    content = (
      <List>
        {reversed.map((tx) => (
          <HistoryItemStyled key={tx.hash} tx={tx} />
        ))}
      </List>
    )
  } else {
    content = <StatusText>You haven't sent any transactions, yet.</StatusText>
  }

  return (
    <Modal title="History" onClose={onClose}>
      {content}
    </Modal>
  )
}

const List = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`

const HistoryItemStyled = styled(HistoryItem)`
  margin: 0;
  position: relative;

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 20px;
    width: calc(100% - 40px);
    height: 1px;
    background-color: ${Colors.LighterGray};
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`

const StatusText = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`
